import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { WorkingLeadCard } from 'src/modules/assistant/components/WorkingLeadCard';
import { TWorkingLead } from 'src/modules/assistant/types/workingLead';

const LOADING_SIZE = 20;

const useStyles = makeStyles((theme: Theme) => ({
    list: {
        display: 'grid',
        gap: theme.spacing(1.25),
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        [theme.breakpoints.down('xs')]: { gridTemplateColumns: '1fr' },
    },
}));

interface WorkingLeadsListProps {
    workingLeads: TWorkingLead[];
    hasMore: boolean;
    loading: boolean;
    onLoadMore: () => void;
    onSelect: () => void;
}

export const WorkingLeadsList = ({
    workingLeads,
    hasMore,
    loading,
    onLoadMore,
    onSelect,
}: WorkingLeadsListProps) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box display="grid" gridGap={10}>
            <Typography variant="subtitle2">
                {t('Assistant.WorkingLeads')}
            </Typography>
            {workingLeads.length ? (
                <div className={classes.list}>
                    {workingLeads.map((workingLead) => (
                        <WorkingLeadCard
                            key={workingLead.id}
                            onSelect={onSelect}
                            workingLead={workingLead}
                        />
                    ))}
                </div>
            ) : loading ? (
                <Box display="flex" justifyContent="center">
                    <CircularProgress
                        aria-label={t('Assistant.Loading')}
                        size={LOADING_SIZE}
                    />
                </Box>
            ) : (
                <Typography color="textSecondary" variant="caption">
                    {t('Assistant.NoWorkingLeads')}
                </Typography>
            )}
            {hasMore && (
                <Button
                    disabled={loading}
                    fullWidth
                    onClick={onLoadMore}
                    size="small"
                    variant="outlined"
                >
                    {loading
                        ? t('Assistant.Loading')
                        : t('Assistant.LoadMoreLeads')}
                </Button>
            )}
        </Box>
    );
};
